import * as AppActions from './App';
import * as ChatActions from '../../chat/actions/Chat';
import * as ProfileActions from './Profile';
import * as RegistrationActions from './Registration';
import { push } from 'connected-react-router'
import axios from '../../shared/axiosConfig';

export const LoginActions = {
  SET_ATTRIBUTE: "LOGIN_SET_ATTRIBUTE",
  RESET_STATE: "LOGIN_RESET",
  ADD_ERROR: "LOGIN_ADD_ERROR",
};

/**
 * @param {String} key
 * @param {*} value
 */
export const setLoginAttribute = (key, value) => {
  return {
    type: LoginActions.SET_ATTRIBUTE,
    key,
    value
  };
};

export const addLoginError = (key, value) => {
  return {
    type: LoginActions.ADD_ERROR,
    key,
    value
  };
};

export const clearErrors = () => {
  return {
    type: LoginActions.SET_ATTRIBUTE,
    key: 'errors',
    value: {},
  }
}

export const resetState = () => {
  return {
    type: LoginActions.RESET_STATE
  }
}

export const openLoginDialog = () => (dispatch, getState) => {
  dispatch( setLoginAttribute('success', false));
  dispatch( setLoginAttribute('codeRequested', false) );
  dispatch( setLoginAttribute('open', true));
}

export const closeLoginDialog = () => (dispatch, getState) => {
  dispatch( setLoginAttribute('open', false));
}

export const doLogin = (code) => async (dispatch, getState) => {
  let phone = getState().login.phone;
  let eventId = getState().event.eventId;
  console.log("Phone is ", phone);
  console.log("Login code is ", code);
  dispatch( setLoginAttribute('inProgress', true) );
  await axios.post(`/api/jobseeker/login`, {phone, code, eventId})
    .then( async (res) => {
      dispatch( setLoginAttribute('codeRequested', false) );
      dispatch( setLoginAttribute('success', true) );
      setTimeout( () => {
        dispatch( setLoginAttribute('open', false) );
      }, 500);
      await dispatch(ProfileActions.fetchProfile());
      await dispatch(RegistrationActions.fetchRegistration())
      dispatch( setLoginAttribute('inProgress', false) );
    })
    .catch( function(err) {
      dispatch( setLoginAttribute('errors', err.response.data.error) );
      dispatch( setLoginAttribute('inProgress', false) );
    });
}

export const requestLoginCode = (phone,resend) => async (dispatch, getState) => {
  dispatch(clearErrors());
  dispatch( setLoginAttribute('codeRequested', false) );
  let numericPhone = phone.replace(/\D/g,'');
  dispatch( setLoginAttribute('phone', numericPhone) );
  if( numericPhone.length < 10 ) {
    dispatch(addLoginError('phone', 'Please provide 10 digits US phone number'));
  }else {
    // send API request for code
    dispatch( setLoginAttribute('inProgress', true) );
    let data = {phone: numericPhone};
    if( resend ) data['resend'] = true;
    await axios.post(`/api/sms`, data )
      .then( async (res) => {
        dispatch( setLoginAttribute('inProgress', false) );
        dispatch( setLoginAttribute('codeRequested', true) );
        if( resend ) alert("We have emailed you login code, please check your mailbox.");
      })
      .catch( function(err) {
        dispatch( setLoginAttribute('inProgress', false) );
        dispatch( setLoginAttribute('errors', err.response.data.error) );
      });
  }
}

